/**
 * @generated SignedSource<<39ab3dd26c720b37a3fc9e0469f85a8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReorderNavSectionInput = {
  navSectionId: string;
  ordering: number;
};
export type ProductsSidebarDragDropProvider_ReorderNavSectionMutation$variables = {
  input: ReorderNavSectionInput;
};
export type ProductsSidebarDragDropProvider_ReorderNavSectionMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly ordering: number;
    } | null;
  };
};
export type ProductsSidebarDragDropProvider_ReorderNavSectionMutation = {
  response: ProductsSidebarDragDropProvider_ReorderNavSectionMutation$data;
  variables: ProductsSidebarDragDropProvider_ReorderNavSectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReorderNavSectionResponse",
    "kind": "LinkedField",
    "name": "reorderNavSection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NavSection",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ordering",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductsSidebarDragDropProvider_ReorderNavSectionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductsSidebarDragDropProvider_ReorderNavSectionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f3bd4c22370634d3d4e1ee7640919bee",
    "id": null,
    "metadata": {},
    "name": "ProductsSidebarDragDropProvider_ReorderNavSectionMutation",
    "operationKind": "mutation",
    "text": "mutation ProductsSidebarDragDropProvider_ReorderNavSectionMutation(\n  $input: ReorderNavSectionInput!\n) {\n  response: reorderNavSection(input: $input) {\n    node {\n      id\n      ordering\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "284894bed1ed1fd3503dd3cd59d4e07a";

export default node;
